import React, { useContext } from "react";
import SellAssetItem from "./sellAssetItem";
import { TownContext } from "../../shared/townContext";

const SellLivestock = ({ town, name }) => {
  let { property } = useContext(TownContext)
  const sellEndpoint = `/students/towns/${town.id}/properties/${property.id}/livestock/sell`
  const marketPriceEndpoint = `/students/towns/${town.id}/markets/livestock_prices?name=${name}`


  return (<>
    <SellAssetItem name={name} sellEndpoint={sellEndpoint} marketPriceEndpoint={marketPriceEndpoint}
                   step={town.step} initialCount={property.livestock_owned[name]} />
  </>);
}

export default SellLivestock
